<template>
  <div class="adviser-enrolment-wrapper">
    <div class="adviser-enrolment-content">
      <!-- Hidden form to prevent autofill -->
      <div style="display: none">
        <input type="text" name="fakeusernameremembered" />
        <input type="password" name="fakepasswordremembered" />
      </div>
      <div>
        <h1>Get Registered</h1>
        <p>
          Get started by submitting your details below to be registered on the
          Online Wills platform.
        </p>
        <ValidationObserver ref="observer">
          <v-form
            ref="form"
            v-model="formValid"
            lazy-validation
            @submit.prevent="submitForm"
            autofocus="false"
            class="adviser-enrolment-form"
            autocomplete="off"
          >
            <v-row>
              <v-col cols="12">
                <ValidationProvider
                  id="first_names"
                  v-slot="{ errors }"
                  name="first_names"
                  rules="required"
                >
                  <v-text-field
                    v-model.trim="formData.firstNames"
                    label="First names*"
                    :error-messages="errors"
                    autocomplete="off"
                    :readonly="false"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  id="last_name"
                  v-slot="{ errors }"
                  name="last_name"
                  rules="required"
                >
                  <v-text-field
                    v-model.trim="formData.lastName"
                    label="Last name*"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  id="email"
                  v-slot="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <v-text-field
                    id="email"
                    v-model.trim="formData.email"
                    :error-messages="errors"
                    label="Email"
                    autocomplete="new-email"
                    :readonly="false"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  id="adviserCode"
                  v-slot="{ errors }"
                  name="adviserCode"
                  rules="required"
                >
                  <v-text-field
                    label="Adviser Code"
                    v-model="formData.adviserCode"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  id="company"
                  v-slot="{ errors }"
                  name="company"
                  rules="required"
                >
                  <v-select
                    label="Company"
                    :items="companies"
                    item-text="text"
                    item-value="value"
                    v-model="formData.company"
                    :error-messages="errors"
                    :menu-props="{ offsetY: true, zIndex: 200 }"
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  id="password"
                  v-slot="{ errors }"
                  name="password"
                  rules="required|password"
                >
                  <v-text-field
                    v-model="formData.password"
                    :error-messages="errors"
                    :append-icon="showPassword ? icons.mdiEye : icons.mdiEyeOff"
                    :type="showPassword ? 'text' : 'password'"
                    label="Password"
                    @click:append="showPassword = !showPassword"
                    autocomplete="new-password"
                    :readonly="false"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  id="confirm password"
                  v-slot="{ errors }"
                  name="confirm password"
                  rules="required|confirmed:password"
                >
                  <v-text-field
                    v-model="formData.confirmPassword"
                    :error-messages="errors"
                    :append-icon="
                      showConfirmPassword ? icons.mdiEye : icons.mdiEyeOff
                    "
                    :type="showConfirmPassword ? 'text' : 'password'"
                    label="Confirm Password"
                    @click:append="showConfirmPassword = !showConfirmPassword"
                    autocomplete="new-password"
                    :readonly="false"
                  />
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  id="accepted_terms"
                  v-slot="{ errors }"
                  name="accepted_terms"
                  :rules="{ is: [true] }"
                >
                  <v-checkbox
                    v-model="formData.acceptedTerms"
                    color="primary"
                    :error-messages="errors"
                  >
                    <template #label>
                      <div class="terms-and-conditions-container">
                        By signing up, I accept
                        <a
                          :href="
                            $router.resolve({ name: 'TermsAndConditions' }).href
                          "
                          target="_blank"
                          @click.stop
                        >
                          {{ whitelabel.name }}'s terms & conditions
                        </a>
                      </div>
                    </template>
                  </v-checkbox>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" class="text-center">
                <GradientButton
                  :title="'SUBMIT'"
                  :small="true"
                  :callout="'right'"
                  :type="'submit'"
                />
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
        <v-row>
          <v-col cols="12" class="mt-12">
            <p>
              If you have any questions about the registration process, please
              don't hesitate to contact us at
              <a href="mailto:adviser@oldmutualwill.co.za"
                >adviser@oldmutualwill.co.za</a
              >
            </p>
          </v-col>
        </v-row>
        <div class="download-faqs-banner-container">
          <div class="download-faqs-banner">
            <div class="content elevation-5">
              <p>
                <span>Pilot FAQs</span>
              </p>
              <div class="download-faqs-banner-button">
                <GradientButton
                  title="DOWNLOAD PDF"
                  :type="'button'"
                  @gradientButtonClicked="downloadFAQs"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="download-faqs-banner-container customer-brochure">
          <div class="download-faqs-banner">
            <div class="content elevation-5">
              <p>
                <span>Customer Brochure</span>
              </p>
              <div class="download-faqs-banner-button">
                <GradientButton
                  title="DOWNLOAD PDF"
                  :type="'button'"
                  @gradientButtonClicked="downloadCustomerBrochure"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <v-img
        class="mb-12"
        :src="
          require(`@/assets/old_mutual/adviser-enrolment/adviser-enrolment-image1.png`)
        "
      /> -->

      <div class="faq">
        <h1>Frequently Asked Questions</h1>
        <div
          v-for="(category, index) in faqCategories"
          :key="index"
          class="faq-category"
        >
          <h2 class="om-green">{{ category.title }}</h2>
          <div
            v-for="(faq, faqIndex) in category.faqs"
            :key="faqIndex"
            class="faq-item"
          >
            <p class="question mb-2 semi-bold">Q: {{ faq.question }}</p>
            <p class="answer" v-html="faq.answer"></p>
          </div>
        </div>
      </div>
      <div id="terms" class="terms mb-12 pb-12">
        <h1>Terms and Conditions</h1>
        <ol>
          <li v-for="(term, index) in terms" :key="index">
            {{ term }}
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorSnackbar from "@/components/common/ErrorSnackbar.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { REGISTER_ADVISER_MUTATION } from "@/constants/graphql/advisors";
import * as Sentry from "@sentry/browser";

export default {
  name: "AdviserEnrolmentContent",
  components: {
    ValidationProvider,
    ValidationObserver,
    ErrorSnackbar,
  },
  data() {
    return {
      formValid: false,
      formData: {
        firstNames: "",
        lastName: "",
        email: "",
        adviserCode: "",
        company: null,
        password: "",
        confirmPassword: "",
        acceptedTerms: false,
      },
      showPassword: false,
      showConfirmPassword: false,
      companies: [
        { text: "OM Personal Finance - AFD", value: "OM_PF_AFD" },
        { text: "OM Personal Finance - DFA", value: "OM_PF_DFA" },
        { text: "OM Personal Finance - PFA", value: "OM_PF_PFA" },
        { text: "Other", value: "OTHER" },
      ],
      faqCategories: [
        {
          title: "Legality & Security",
          faqs: [
            {
              question:
                "Is creating a will online with Old Mutual legally valid?",
              answer:
                "<strong>A</strong>: Yes. A will created through Old Mutual is legally binding as long as it meets the necessary legal requirements, such as proper signing and witnessing. Clients will receive clear instructions to ensure compliance.",
            },
            {
              question:
                "How does Old Mutual ensure the security of my clients' personal information?",
              answer:
                "<strong>A</strong>: Old Mutual uses industry-leading encryption and security protocols to protect sensitive data. All personal and financial details remain confidential and are never shared without consent.",
            },
            {
              question:
                "Who is eligible to use Old Mutual's online will service?",
              answer:
                "<strong>A</strong>: The service is available to South African residents aged 16 years or older.",
            },
          ],
        },
        {
          title: "Making Changes & Storage",
          faqs: [
            {
              question:
                "Can my client make changes to their will after they've created it?",
              answer:
                "<strong>A</strong>: Yes! Clients can edit their will at any time before finalizing and signing it. It's advisable to update a will after major life events such as marriage, divorce, having children, or acquiring significant assets.",
            },
            {
              question: "Does Old Mutual charge a storage fee?",
              answer:
                "<strong>A</strong>: No. Storage and one collection of the signed will are free of charge once per year. This ensures the original will is securely stored and accessible when needed.",
            },
          ],
        },
        {
          title: "Process & Costs",
          faqs: [
            {
              question:
                "What does it cost for my client to create a will with Old Mutual?",
              answer:
                "<strong>A</strong>: Absolutely nothing. The will drafting service is completely free.",
            },
            {
              question: "How does the process work?",
              answer:
                "<strong>A</strong>:<br>1. The adviser guides the client through the online will creation process.<br>2. The client reviews, prints, signs, and has their will witnessed as per legal requirements.<br>3. The signed will is uploaded onto the system for validation.<br>4. The signed & validated will is collected (free once per year) and securely stored by Old Mutual.",
            },
            {
              question:
                "What happens if a client does not sign or return their will?",
              answer:
                "<strong>A</strong>: If a will is not signed and validated, it will not be legally binding. Advisers should encourage clients to follow through with signing and submission to complete the process. It is to the benefit of the customer to store his / her will with Old Mutual, but this is not a requirement. This is a benefit, free of charge, to the customer.",
            },
          ],
        },
        {
          title: "Adviser Incentive & Earnings",
          faqs: [
            {
              question:
                "How do I qualify for the R750 (pre-tax) incentive per will?",
              answer:
                "<strong>A</strong>:<br>The will must be signed and validated between 1 – 30 April 2025.<br>Only wills facilitated through registered Old Mutual advisers qualify.<br>Payments will be processed after verification of each successful will submission.<br>Wills updated and validated that have been submitted within the previous 12 months will not qualify for the incentive.",
            },
            {
              question:
                "How do I register as an adviser on the Old Mutual Will platform?",
              answer:
                "<strong>A</strong>:<br>1. Click here to register.<br>2. Complete the sign-up form and receive login details.<br>3. Start assisting clients and earning incentives.",
            },
          ],
        },
        {
          title: "Additional Adviser Support",
          faqs: [
            {
              question: "Can I track my submitted wills and earnings?",
              answer:
                "<strong>A</strong>: Yes, advisers will have access to a dashboard where they can track submitted wills and qualifying incentives.",
            },
            {
              question:
                "Where can I get assistance if I or my clients need help?",
              answer:
                "<strong>A</strong>: Our support team is ready to assist! Contact us at:<br>• adviser@oldmutualwill.co.za<br>• 021 – 75303248<br>(Monday – Friday, 08:00 – 17:00)",
            },
          ],
        },
      ],
      terms: [
        "The pilot will run from 1 April 2025 until 30 April 2025.",
        "To qualify for the incentive, a will must be signed and validated.",
        "There is no limit per will per adviser, and the first 330 signed, validated and delivered wills will earn the R750 (pre-tax) incentive.",
        "It is at the discretion of PF and Old Mutual Will to extend the pilot.",
        "Weekly reports will be provided to PF to share with the relevant advisers",
        "Personal Finance will make payment to the relevant advisers via OMIpay.",
        "All queries must be directed to PF that will resolve the issues with Old Mutual Will.",
      ],
    };
  },
  methods: {
    downloadFAQs(event) {
      if (event) event.preventDefault();
      try {
        const link = document.createElement("a");
        link.href = "pdfs/Adviser-Enrolment-FAQs.pdf";
        link.download = "Adviser-Enrolment-FAQs.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error opening PDF:", error);
      }
    },
    downloadCustomerBrochure(event) {
      if (event) event.preventDefault();
      try {
        const link = document.createElement("a");
        link.href = "pdfs/Customer-Brochure.pdf";
        link.download = "Customer-Brochure.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error opening PDF:", error);
      }
    },
    async submitForm() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.register();
      }
    },
    async register() {
      try {
        const result = await this.$apollo.mutate({
          mutation: REGISTER_ADVISER_MUTATION,
          variables: {
            firstNames: this.formData.firstNames,
            lastName: this.formData.lastName,
            email: this.formData.email,
            adviserCode: this.formData.adviserCode,
            company: this.formData.company,
            password: this.formData.password,
          },
        });

        const registerAdviser = result.data.registerAdviser;
        this.$store.dispatch("login", {
          accessToken: registerAdviser.accessToken,
          refreshToken: registerAdviser.refreshToken,
          testatorId: registerAdviser.testatorId,
          userId: registerAdviser.userId,
          willCountry: registerAdviser.willCountry,
          companyId: registerAdviser.companyId,
        });
        this.setSentryUser(registerAdviser.userId);
        this.$router.push("/admin");
      } catch (error) {
        if (error.message.includes("users.index_users_on_email")) {
          return;
        }
        const cleanError = error.message.replace("GraphQL error: ", "");
        this.$emit("showErrorMessage", cleanError);
      }
    },
    setSentryUser(userId) {
      Sentry.setUser({ id: userId });
    },
  },
  computed: {
    isMobile() {
      return this.$isMobileDevice();
    },
  },
};
</script>

<style scoped lang="scss">
.adviser-enrolment-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: visible;
}

.adviser-enrolment-content {
  width: 100%;
  max-width: 768px;
  justify-self: center;
  position: relative;
  z-index: 1;

  .adviser-enrolment-form {
    padding: 5%;
    background-color: white;
  }

  .download-faqs-banner-container {
    padding-top: 80px;
    padding-bottom: 80px;

    &.customer-brochure {
      padding-top: 0;
      padding-bottom: 80px;
    }

    .download-faqs-banner {
      .content {
        background-color: #ffffff;
        padding: 47px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .download-faqs-banner-button {
          margin-left: auto;
        }
        @media only screen and (max-width: 959px) {
          .download-faqs-banner-button {
            margin-left: 0;
          }
        }

        p {
          font-family: Montserrat;
          margin: 0;
          font-size: 28px;
          font-weight: 300;
          line-height: 34px;
          letter-spacing: -0.0025em;
          text-align: left;
          margin-right: 30px;

          span {
            font-family: Montserrat;
            font-size: 28px;
            font-weight: 500;
            line-height: 34px;
            letter-spacing: -0.0025em;
          }
        }
        @media only screen and (max-width: 959px) {
          .content {
            justify-content: center !important;
          }
          p {
            text-align: center !important;
          }
        }
      }
    }
  }
}

section {
  margin-bottom: 60px;
}

.semi-bold {
  font-weight: 600 !important;
}
.article-link {
  color: #282828;
  font-weight: 500;
}

h1 {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 28px;
  line-height: 34px;
  margin-bottom: 24px;
  &.intro {
    font-size: 22px;
    font-weight: 400;
    line-height: 26px;
  }
}
h2 {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 22px;
  line-height: 26px;
  margin: 40px 0 24px 0;
  &.sub-heading-one {
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
  }
  &.sub-heading-two {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
  &.om-green {
    color: #50b848;
  }
}

.article-cta {
  color: #50b848;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  a {
    color: #50b848;
    font-family: "Montserrat", sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
  }
}
p,
ul,
li {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 22px;
}
blockquote {
  color: #50b848;
  border-left: 4px solid #50b848;
  padding-left: 24px;
  font-size: 22px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
  margin: 40px 0;
  ul {
    li {
      list-style-type: disc;
      font-family: "Montserrat", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
      text-align: left;

      &::marker {
        color: #50b848;
      }
    }
    p {
      color: #282828;
      font-family: "Montserrat", sans-serif;
      font-weight: 400;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
    }
    &.no-paragraphs {
      li {
        color: #282828;
      }
    }
  }
}
ul {
  margin: 24px 0;
  p {
    margin: 10px 0;
  }
}

.faq-category {
  margin-bottom: 40px;

  .faq-item {
    margin-bottom: 24px;
  }
}

.terms-link {
  color: #009677;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
@media only screen and (min-width: 1264px) and (max-width: 1294px) {
  .download-faqs-banner-container {
    .download-faqs-banner {
      padding-left: 140px;
      padding-right: 140px;
    }
  }
}

@media only screen and (min-width: 960px) and (max-width: 1263px) {
  .download-faqs-banner-container {
    .download-faqs-banner {
      padding-left: 80px;
      padding-right: 80px;
    }
  }
}

@media only screen and (min-width: 0px) and (max-width: 959px) {
  .download-faqs-banner-container {
    padding-top: 50px;
    padding-bottom: 50px;
    .download-faqs-banner {
      padding-left: 26px;
      padding-right: 26px;
      .content {
        flex-direction: column;
        padding: 26px !important;
        p {
          margin-right: 0 !important;
          margin-bottom: 30px !important;
        }
      }
    }
  }
}
</style>
